function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.707 20.293l-4.539-4.539a8.527 8.527 0 10-1.414 1.414l4.539 4.539a1 1 0 001.414-1.414zM10.5 17a6.5 6.5 0 116.5-6.5 6.508 6.508 0 01-6.5 6.5z",
  fill: "#none"
});

var SvgIconLSearch = function SvgIconLSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I25vbmU7fTwvc3R5bGU+PC9kZWZzPjxnPjxwYXRoIGNsYXNzPSJhIiBkPSJNMjEuNzA3LDIwLjI5M2wtNC41MzktNC41MzlhOC41MjcsOC41MjcsMCwxLDAtMS40MTQsMS40MTRsNC41MzksNC41MzlhMSwxLDAsMCwwLDEuNDE0LTEuNDE0Wk0xMC41LDE3QTYuNSw2LjUsMCwxLDEsMTcsMTAuNSw2LjUwOCw2LjUwOCwwLDAsMSwxMC41LDE3WiIvPjwvZz48L3N2Zz4K";
export { SvgIconLSearch as ReactComponent };